import { Service, ApiResponse } from "@roc/feature-app-core";

export class InsuranceDashboardInternalService extends Service {

  getInsuranceDashbboard(type: string, page: number, pageSize: number, sortDir: string, sortBy: string, filters: object, dropdownFilters: string): Promise<ApiResponse> {
    return this.get('/nportal/rest/priv/insurance/v2/getInsuranceDashboard', { type, page, pageSize, sortDir, sortBy, filters, dropdownFilters });
  }
}